// passing the path into variables

const destination1 = '/assets/viatur/destination/lautaro.png'
const destination2 = '/assets/viatur/destination/loncoche.png'
const destination3 = '/assets/viatur/destination/los-angeles.png'
const destination4 = '/assets/viatur/destination/osorno.png'
const destination5 = '/assets/viatur/destination/pitrufquen.png'
const destination6 = '/assets/viatur/destination/puerto-montt.png'
const destination7 = '/assets/viatur/destination/puerto-varas.png'
const destination8 = '/assets/viatur/destination/rio-bueno.png'
const destination9 = '/assets/viatur/destination/santiago.png'
const destination10 = '/assets/viatur/destination/temuco.png'
const destination11 = '/assets/viatur/destination/valdivia.png'


const gallery1 = '/assets/viatur/home/bus1.png'
const gallery2 = '/assets/viatur/home/bus2.png'
const gallery3 = '/assets/viatur/home/bus3.png'
const gallery4 = '/assets/viatur/home/bus4.png'
const gallery5 = '/assets/viatur/home/bus5.png'
const gallery6 = '/assets/viatur/home/bus6.png'
const gallery7 = '/assets/viatur/home/bus7.png'


const destination = [destination1, destination2, destination3, destination4, destination5, destination6, destination7, destination8, destination9, destination10, destination11];

const gallery = [gallery1, gallery2, gallery3, gallery4, gallery5, gallery6, gallery7];



const viaturSlides = {
    destination,
    gallery
}

export default viaturSlides


// WEBPACK FOOTER //
// ./src/features/themes/functions/getSlides/viaturSlides.js